import { useCallback } from 'react';
import { useDContext } from '../contexts';
import formatCurrency from '../utils/formatCurrency';
export default function useFormatCurrency(...args) {
    const { currency } = useDContext();
    const format = useCallback((value, currencyOptions) => formatCurrency(value, currencyOptions || currency), [currency]);
    const values = (args || []).map((value) => (formatCurrency(value !== null && value !== void 0 ? value : 0, currency)));
    return {
        format,
        values,
    };
}
//# sourceMappingURL=useFormatCurrency.js.map